// Turns a raw User-Agent string into a short "Browser on OS" label for
// display (trusted-devices list). Not a full UA parser — just enough to tell
// devices apart at a glance. Order matters: Edge/OPR embed "Chrome" in their
// UA, and Chrome embeds "Safari", so more specific checks must run first.
const BROWSER_PATTERNS = [
  ['Edge', /Edg\//],
  ['Opera', /OPR\//],
  ['Chrome', /Chrome\//],
  ['Firefox', /Firefox\//],
  ['Safari', /Safari\//],
]

const OS_PATTERNS = [
  ['iPhone', /iPhone/],
  ['iPad', /iPad/],
  ['Android', /Android/],
  ['Windows', /Windows/],
  ['macOS', /Mac OS X/],
  ['Linux', /Linux/],
]

export function deviceLabel(userAgent) {
  if (!userAgent || !userAgent.trim()) return 'Unknown device'

  const browser = BROWSER_PATTERNS.find(([, re]) => re.test(userAgent))?.[0]
  const os = OS_PATTERNS.find(([, re]) => re.test(userAgent))?.[0]

  if (browser && os) return `${browser} on ${os}`
  if (browser) return browser
  if (os) return os
  // Doesn't look like a real UA string (e.g. a stray DevTools override) —
  // showing it verbatim is more useful than a generic label.
  return userAgent
}
